import { createContext, useContext, useState, useEffect } from "react";
import api from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=anon, object=logged
  const [mustChangePassword, setMustChangePassword] = useState(false);

  useEffect(() => {
    api.get("/auth/me").then((r) => {
      setUser(r.data);
      setMustChangePassword(!!r.data?.must_change_password);
    }).catch(() => setUser(false));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("erp_token", data.access_token);
    setUser(data.user);
    setMustChangePassword(!!data.must_change_password || !!data.user?.must_change_password);
    return data.user;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (e) {}
    localStorage.removeItem("erp_token");
    setUser(false);
    setMustChangePassword(false);
  };

  const can = (...roles) => user && roles.includes(user.role);

  const clearMustChangePassword = () => setMustChangePassword(false);

  return (
    <AuthContext.Provider value={{ user, login, logout, can, mustChangePassword, clearMustChangePassword }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
